export const replaceImmutableArrayItemAt = <T>(
	array: Array<T>,
	index: number,
	value: T,
): Array<T> => {
	const ret = array.slice(0);
	ret[index] = value;
	return ret;
};

export const addOrExcludeValueFromArray = <T>(
	array: Array<T>,
	value: T,
	valueEquals: (a: T, B: T) => boolean = (a, b) => a === b,
): Array<T> => {
	return array.find((i) => valueEquals(i, value))
		? array.filter((i) => !valueEquals(i, value))
		: [...array, value];
};

export const getUniqueItems = <T>(array: Array<T>): Array<T> => {
	return array.filter((value, index, a) => {
		return a.indexOf(value) === index;
	});
};

export const filterNulls = <T>(array: Array<T | null | undefined>): Array<T> => {
	return array.filter((v) => v !== null && v !== undefined) as Array<T>;
};

export const associateBy = <T>(
	array: Array<T>,
	getKey: (value: T) => string | number,
): {
	[key: string | number]: T;
} => {
	const entries = array.map((item) => [getKey(item), item] as [string | number, T]);
	return Object.fromEntries(entries);
};
